"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheCircularProgress = void 0;

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _core = require("../core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Progress indicators express an unspecified wait time or display the length of a process.
 *
 * Progress indicators inform users about the status of ongoing processes, such as loading an app, submitting a
 * form, or saving updates. They communicate an app’s state and indicate available actions, such as whether users
 * can navigate away from the current screen.
 *
 * Determinate indicators display how long an operation will take.
 * Indeterminate indicators visualize an unspecified wait time.
 */
var RocheCircularProgress = _CircularProgress["default"];
exports.RocheCircularProgress = RocheCircularProgress;
RocheCircularProgress.displayName = (0, _core.rochePrefix)('CircularProgress');
RocheCircularProgress.defaultProps = {
  color: 'primary',
  size: 80,
  thickness: 3,
  variant: 'indeterminate'
};
var _default = RocheCircularProgress;
exports["default"] = _default;